import { ChangeEvent, useCallback, useState } from "react";
import { validateMaxChar } from "../utils/validators";
import { useAppSelector } from "../../common/store";

const useMaxChar = (warningThreshold = 0.8) => {
  const [inputValue, setInputValue] = useState('');
  const [warning, setWarning] = useState('');
  const [isReachedLimit, setIsReachedLimit] = useState(false);
  const maxChar = useAppSelector(state => state.theme.themeConfig.maxChar);

  const handleInputOnChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    let value = e?.target?.value || '';
    if (value.length > maxChar) {
      value = value.slice(0, maxChar);
    }
    setWarning('');
    setIsReachedLimit(false);
    const { charCount, isLimitReached } = validateMaxChar(value, maxChar);

    if (charCount >= maxChar * warningThreshold) {
      setWarning(isLimitReached ? `Max limit of ${maxChar} characters reached` : charCount>=250 ? `${charCount} of ${maxChar}` : '');
      setIsReachedLimit(isLimitReached);
    }


    if (charCount >= (maxChar + 1) && value.endsWith(' ')) return;
    setInputValue(value);
  }, [maxChar]);

  return {
    handleInputOnChange,
    inputValue,
    setInputValue,
    warning,
    isReachedLimit,
  }
}

export default useMaxChar;
